import styled from 'styled-components'

export const DetailsBlock = styled.div`
  padding: 0.5rem 0 0.25rem;
`
